import React from "react";
import Typography from "../../atoms/typography";
import ImageTile from "../../atoms/imageTile";
import { MAKE_IT_EXTRA_SPECIAL } from "../../../constants/common/common";
import { useSelector } from "react-redux";
import PropType from "prop-types";
import ButtonComponent from "../../atoms/button";

/**
 * Component that renders the header for the add-on section,
 * including a close button to dismiss the add-ons view.
 *
 * @param {Object} props - The component props.
 * @param {function} props.onClose - Function to handle closing the add-on view.
 * @returns {JSX.Element} The rendered add-on header component.
 */
const AddonHeader = ({ onClose }) => {
  const isMobile = useSelector((state) => state?.appConfig?.isMobile);

  return (
    <div className="flex items-center gap-[8px]">
      {isMobile ? (
        <div onClick={onClose} className="cursor-pointer">
          <ImageTile imgSrc={"/icons/left-arrow.svg"} imgHeight={20} imgWidth={20} imgAlt={"left-side-arrow"} />
        </div>
      ) : (
        <div className="absolute right-5">
          <ButtonComponent
            buttonVariant="icon"
            icon="/icons/close-circle-black.svg"
            btnParentClasses="flex justify-end"
            onClick={onClose}
            classes="border-0 "
            size="large"
          />
        </div>
      )}

      <Typography classes="font-600 text-16" variant="h6" Tag="p">
        {MAKE_IT_EXTRA_SPECIAL}
      </Typography>
    </div>
  );
};

AddonHeader.propTypes = {
  onClose: PropType.func.isRequired,
};

export default AddonHeader;
